import { Observable } from "rxjs/Observable";

export class BaseService{
    protected static readonly RETRIES: number = 1;

    constructor(){
    }

    protected catchErrors(error: any){
        let errorMessage: string;
        if(error.message){
            errorMessage = error.message;
        }else if(error.status){
            errorMessage = `${error.status} - ${error.statusText}`;
        }else{
            errorMessage = "HTTP Error.";
        }

        console.log(errorMessage);
        return Observable.throw(errorMessage);
    }

    protected parseResponse(resp: Response): any{
        return resp.json() || {};
    }

    protected parseArray(array: any): any{
        return array.data || [];
    }
}


// WEBPACK FOOTER //
// /home/ppeters/filmCritClient/src/app/services/base.service.ts